import { dimensions } from '~/store/dimensions.js';

export default function ({ app: { router }, store }) {
  router.beforeResolve(({ name }, from, next) => {
    const dimension = dimensions.find((item) => name.includes(item.path));
    store.dispatch('dimensions/ACTUAL_DIMENSION', dimension?.name || dimensions[0].name);
    next();
  });
}
